const moviesContent = [
  // Example movie structure - add your movies here
  // {
  //   title: "Movie Title",
  //   slug: "movie-title", // URL-friendly version of title
  //   director: "Director Name",
  //   country: "Country",
  //   year: 2024,
  //   image: require("../img/movies/movie-image.jpg"),
  //   review: `Your review text goes here. You can use multiple paragraphs by using template literals.
  //
  //   This is a second paragraph.`
  // },

  {
    title: "Le Bonheur",
    slug: "Le-Bonheur", // URL-friendly version of title
    director: "Agnès Varda",
    country: "France",
    year: 1965,
    image: require("../img/movies/le-bon.jpg"),
    review: `_Le Bonheur_ is a colorful French film directed by Agnès Varda in 1975. 
              The story follows François, a carpenter, and his seamstress wife Thérèse, 
              who are happily in love and have two children. However, while working on a 
              job in the city, François meets another woman who he falls for immediately. 
              Beneath its overwhelmingly radiant aesthetic, the film masks themes of infidelity and patriarchy.

              Between the outfits of our characters, the landscapes, and the solid color cuts 
              placed between scenes, we are spoiled in each shot with beautiful stills and rich tones. 
              Apart from the visuals, it is clear that Varda uses these colors to represent François 
              and his version of “happiness.” We as viewers expect to see a diminished state of color 
              throughout his acts of selfishness, but instead see that his happiness remains through 
              and through, telling of his character and the message Varda is portraying through him. 

              Although I found the plot to be flat overall, Varda’s capability of showing the power 
              struggle between Francois and Therese, and the opposing consequences for both characters 
              visually is where the film succeeds most. Its an impressive watch that keeps your eyes glued 
              to the screen to catch every shade of color being displayed. I enjoyed it and look forward to 
              exploring more of Varda’s work in the future.`,
  },

  {
    title: "Mulholland Drive",
    slug: "Mulholland-Drive",
    director: "David Lynch",
    country: "USA",
    year: 2001,
    image: require("../img/movies/mulholland-drive.jpg"),
    review: `Despite never having watched his work until now, I had always admired David Lynch for his quirky personality, his influence on film, and the mystique surrounding his name. He’s known for his dreamy, surreal style and has the honor of having strange, disturbing images described as “Lynchian.” I’ve always loved absurd and bizarre media, so I had kept his films on the shelf until I felt ready to truly explore them.

_Mulholland Drive_ follows a woman attempting to uncover her true identity with the help of an aspiring actress newly arrived in Los Angeles. Where the story ultimately leads depends largely on how we interpret what we’re seeing, or choose to believe. 

The film strongly reminds me of Ingmar Bergman’s _Persona_, another favorite of mine, where consciousness, identity, and truth blur through the interactions of its protagonists. I love both films because they refuse to hand over an easy explanation for what you’ve just seen. Ambiguity, dreamlike atmosphere, and psychological tension are the true highlights.

_Mulholland Drive_ is easily one of the best films I’ve seen in a while. It checks every box that a great movie should have. What I love most, though, is Lynch’s "[apple pie](https://www.youtube.com/shorts/gvCXB_VVpa8)" personality woven throughout, especially in the narrative itself. I enjoyed every moment, especially the week that followed where I couldn't stop thinking about it. 

I’m happy to have finally delved into his work and to better understand the kind of genius we unfortunately lost last year. I cannot wait to dive deeper into his filmography and continue to be left confused.

_Silencio_`,
  },
];

export default moviesContent;
